<div class="main-container">

  <form [formGroup]="newPasswordForm" (ngSubmit)="Actualizar()">

    <div class="fila1">
      <div class="superior">
        <h2 mat-dialog-title>{{ 'cambiarClave' | translate }}</h2>
        <div class="iconos-superior">
          <button
            [disabled]="passwordLevel < 100 || newPasswordForm.invalid"
            type="submit"
            matTooltip="{{ 'guardar' | translate }}"
            matTooltipClass="colortooltip"
            mat-icon-button>
            <mat-icon
              color="primary"
            [ngClass]="{ deshabilitar: passwordLevel < 100 || newPasswordForm.invalid }">check</mat-icon>
          </button>
          <button
            matTooltip="{{ 'cancelar' | translate }}"
            matTooltipClass="colortooltip"
            mat-icon-button
            (click)="closeDialog()"
            type="button">
            <mat-icon color="warn">close</mat-icon>
          </button>
        </div>
      </div>
    </div>

    <mat-form-field>
      <mat-label>{{ 'clave' | translate }}</mat-label>
      <input
        matInput
        type="password"
        class="inputNuevo"
        formControlName="newPassword"
        />
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{ 'repetirClave' | translate }}</mat-label>
        <input
          matInput
          type="password"
          class="inputNuevo"
          formControlName="passwordConfirm"
          />
        </mat-form-field>
        @if (newPasswordForm?.errors && newPasswordForm?.errors?.misMatch) {
          <mat-hint
            class="text-red"
            >
            La contraseña no es igual
          </mat-hint>
        }

        <div class="requerimientos">

          <div class="config-title">
            <b>La contraseña debe tener</b>
          </div>
          <ul>
            <li
            [ngClass]="{
              'text-red': newPassword.dirty && !checkRule('min-chars'),
              'text-green': checkRule('min-chars')}">
              Mínimo 8 caracteres.
            </li>
            <li
            [ngClass]="{
              'text-red': newPassword.dirty && !checkRule('uppercase'),
              'text-green': checkRule('uppercase')}">
              Al menos una letra mayúscula.
            </li>
            <li
            [ngClass]="{
              'text-red': newPassword.dirty && !checkRule('lowercase'),
              'text-green': checkRule('lowercase')}">
              Al menos una letra minúscula.
            </li>
            <li
            [ngClass]="{
              'text-red': newPassword.dirty && !checkRule('digit'),
              'text-green': checkRule('digit')}">
              Al menos un dígito.
            </li>
            <li
            [ngClass]="{
              'text-red': newPassword.dirty && !checkRule('special-char'),
              'text-green': checkRule('special-char')}">
              Al menos un caracter especial.
            </li>
          </ul>

        </div>

      </form>

    </div>